const setOpen = (box, open) => {
	box.classList.toggle('is-open', open);
	box.querySelector('.faq-toggle')?.setAttribute('aria-expanded', String(open));
	const panel = box.querySelector('.faq-panel');
	if (panel) panel.inert = !open;
};

const init = () => {
	document.querySelectorAll('.faq-layout').forEach((layout) => {
		const boxes = [...layout.querySelectorAll('.faq-box')];

		boxes.forEach((box) => {
			box.querySelector('.faq-toggle')?.addEventListener('click', () => {
				const open = !box.classList.contains('is-open');
				boxes.forEach((other) => other !== box && setOpen(other, false));
				setOpen(box, open);
			});
		});
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
